//src/app/features/conversations/Components/ConversationTitle/index.tsx
import useMediaQueries from 'app/hooks/useMediaQueries';
import { Link } from 'react-router-dom';

interface ConversationTitleProps {
  value: string;
  onChange?: (value: string) => void;
}

export default function ConversationTitle({
  value,
  onChange,
}: ConversationTitleProps) {
  const { md_down: isMobile } = useMediaQueries();

  return (
    <>
      {isMobile && (
        <Link to="..">
          <button
            type="button"
            className="p-2 font-bold text-xl text-green focus:outline-none"
          >
            {'<'}
          </button>
        </Link>
      )}
      <div className="flex-1 mr-6 md-max:text-xs">
        {onChange && (
          <label>
            <input
              maxLength={40}
              className="p-2 placeholder-gray-dark w-full outline-none focus:outline-none text-gray-dark focus:border-green border-b "
              placeholder="Write a Title here..."
              value={value}
              onChange={(e) => onChange(e.target.value)}
            />
          </label>
        )}

        {!onChange && value}
      </div>
    </>
  );
}
